// store/confSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lastFetch: null, // metadato; tutto il resto sono variabili
};

const confSlice = createSlice({
  name: "conf",
  initialState,
  reducers: {
    setConf(state, action) {
      // payload: array [{ variable, value }]
      const map = {};
      (action.payload || []).forEach(v => {
        map[v.variable] = v.value;
      });
      // rimpiazzo l’oggetto conf: variabili al root + lastFetch
      return { ...map, lastFetch: Date.now() };
    },
    clearConf() {
      return { lastFetch: null };
    },
    upsertVariable(state, action) {
      const { variable, value } = action.payload || {};
      if (variable) state[variable] = value;  // al root
    },
  },
});

export const { setConf, clearConf, upsertVariable } = confSlice.actions;

// ---- Selectors
export const selectVar =
  (key, fallback = undefined) =>
  (state) =>
    state.conf[key] ?? fallback;

export const selectConfMap = (state) => {
  const { lastFetch, ...vars } = state.conf || {};
  return vars; // solo mappa variabili
};

export default confSlice.reducer;
